import dayjs from 'dayjs';

import { AvailabilityDatesInterface } from '@valk-nx/availability-dates-store/availability-dates.interface';

export function isArrivalDateValid(
	availability: AvailabilityDatesInterface | undefined,
	arrivalDateKey: string,
): boolean {
	if (!availability) {
		return false;
	}

	const availableDepartures = availability[arrivalDateKey];
	if (!availableDepartures) {
		return false;
	}

	// An arrival date is only valid if it has at least one departure date after the arrival date
	return Object.keys(availableDepartures).some((departureDateKey) => {
		return dayjs(departureDateKey).isAfter(arrivalDateKey, 'day');
	});
}

export function isDepartureDateAvailable(
	availability: AvailabilityDatesInterface | undefined,
	arrivalDateKey: string,
	departureDateKey: string,
): boolean {
	if (!availability) {
		return false;
	}

	return !!availability[arrivalDateKey]?.[departureDateKey];
}

export function validateDates(
	availability: AvailabilityDatesInterface | undefined,
	arrivalDateKey: string,
	departureDateKey?: string,
): {
	isArrivalValid: boolean;
	isDepartureValid: boolean;
} {
	const isArrivalValid = isArrivalDateValid(availability, arrivalDateKey);

	const isDepartureValid = departureDateKey
		? isArrivalValid &&
			isDepartureDateAvailable(
				availability,
				arrivalDateKey,
				departureDateKey,
			)
		: true;

	return {
		isArrivalValid,
		isDepartureValid,
	};
}
